<script>
  import Caution from "$lib/assets/icons/caution.svelte";
  import ChevronDown from "$lib/assets/icons/chevron-down.svelte";
  import ChevronLeft from "$lib/assets/icons/chevron-left.svelte";
  import ChevronRight from "$lib/assets/icons/chevron-right.svelte";
  import ChevronUp from "$lib/assets/icons/chevron-up.svelte";
  import ChevronBackToTop from "$lib/assets/icons/chevron-back-to-top.svelte";
  import Check from "$lib/assets/icons/check.svelte";
  import Close from "$lib/assets/icons/close.svelte";
  import Confirm from "$lib/assets/icons/confirm.svelte";
  import Dollar from "$lib/assets/icons/dollar.svelte";
  import Download from "$lib/assets/icons/download.svelte";
  import Error from "$lib/assets/icons/error.svelte";
  import Euro from "$lib/assets/icons/euro.svelte";
  import External from "$lib/assets/icons/external.svelte";
  import Facebook from "$lib/assets/icons/facebook.svelte";
  import Favorite from "$lib/assets/icons/favorite.svelte";
  import Filter from "$lib/assets/icons/filter.svelte";
  import Info from "$lib/assets/icons/info.svelte";
  import Instagram from "$lib/assets/icons/instagram.svelte";
  import Invisible from "$lib/assets/icons/invisible.svelte";
  import Link from "$lib/assets/icons/link.svelte";
  import Linkedin from "$lib/assets/icons/linkedin.svelte";
  import Menu from "$lib/assets/icons/menu.svelte";
  import Minus from "$lib/assets/icons/minus.svelte";
  import OfDark from "$lib/assets/icons/of-dark.svelte";
  import Of from "$lib/assets/icons/of.svelte";
  import Plus from "$lib/assets/icons/plus.svelte";
  import Pound from "$lib/assets/icons/pound.svelte";
  import Store from "$lib/assets/icons/store.svelte";
  import Twitter from "$lib/assets/icons/twitter.svelte";
  import Visible from "$lib/assets/icons/visible.svelte";
  import Yen from "$lib/assets/icons/yen.svelte";
  import Youtube from "$lib/assets/icons/youtube.svelte";

  export let type;
  export let inheritSize = false;
  let sizeProp = "md";
  let clazz = "";

  export { sizeProp as size };
  export { clazz as class };

  const SIZE_MAP = {
    sm: 16,
    md: 24,
    lg: 48,
    xl: 96 // <-- should only ever be applied to the OF logo
  };

  const ICON_TYPES = {
    caution: Caution,
    "chevron-down": ChevronDown,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    "chevron-up": ChevronUp,
    "chevron-back-to-top": ChevronBackToTop,
    check: Check,
    close: Close,
    confirm: Confirm,
    dollar: Dollar,
    download: Download,
    error: Error,
    euro: Euro,
    external: External,
    facebook: Facebook,
    heart: Favorite,
    favorite: Favorite,
    filter: Filter,
    info: Info,
    instagram: Instagram,
    invisible: Invisible,
    link: Link,
    linkedin: Linkedin,
    menu: Menu,
    minus: Minus,
    "of-dark": OfDark,
    of: Of,
    plus: Plus,
    pound: Pound,
    store: Store,
    twitter: Twitter,
    visible: Visible,
    yen: Yen,
    youtube: Youtube
  };

  const size = SIZE_MAP[sizeProp];
  const isBrandLogo = type === "of" || type === "of-dark";
  const invalidSize = size === "xl" && !isBrandLogo;

  if (!size || invalidSize) {
    /* eslint-disable no-console */
    console.error(
      `[ICON ERROR] - icon size "${sizeProp}" is not supported for icon of type "${type}"`
    );
  }
  if (!Object.keys(ICON_TYPES).includes(type)) {
    /* eslint-disable no-console */
    console.error(`[ICON ERROR] "${type}" is not a supported icon type. `);
  }

  $: component = ICON_TYPES[type];
</script>

{#if inheritSize}
  <svelte:component this={component} aria-hidden="true" class={clazz} />
{:else}
  <svelte:component this={component} aria-hidden="true" width={size} height={size} class={clazz} />
{/if}
